import './EventDetailPage.css'
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { useSelectedItem } from "../context/store";
import Loginpopup from "../Navbar/Loginmodal";
import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import { SlCalender } from "react-icons/sl";
import { IoTimeOutline } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import Accordion from '../CRP/components/Accordion';
import ArtistsCardEventDetail from './ArtistsCardEventDetail';
import EventsListingCard from './EventsListingCard';
import footer1 from '../Footer/image/footer1.png'
import footer2 from '../Footer/image/footer2.png'
import promotion from './image/promotion.jpg'
import EventDetailmenuImageSlider from './EventDetailmenuImageSlider';
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { MdContentCopy } from "react-icons/md";
import FooterTagSection from '../Club-aboutus/custom-comp/FooterTagSection';
import { LiaAddressCardSolid } from 'react-icons/lia';



const faqs = [
    {
        question: "How do I make the payment?",
        answer: `Tap Book Now, select your tickets, pay via UPI/credit card/net banking. You'll receive an instant confirmation with QR-code entry.`,
    },
    {
        question: "How do I access my ticket after booking?",
        answer: "Once your booking is confirmed, your QR-code entry ticket will be sent via:Email, SMS, You can also view it anytime in the “My Bookings” section of the PartyWitty app",
    },
    {
        question: "What’s included in my ticket?",
        answer: "The ₹699 ticket includes entry, a welcome drink, access to the DJ floor, and exclusive offers on food & drinks.",
    },
    {
        question: "What if the date changes?",
        answer: "Event dates may be subject to club discretion—any update will be promptly shared via email/SMS.",
    },
    {
        question: "Can I cancel my ticket after booking?",
        answer: (<>
            <p>Cancellations are subject to the event's cancellation policy. If eligible, refunds will be processed within 5–7 working days</p>
            <br />
            <p>Note: Some events may be non-refundable.</p>
        </>),
    },
    {
        question: "Do I need to carry ID proof?",
        answer: "Yes. Carry a valid government-issued photo ID for age verification and entry. Entry is strictly 18+ or 21+ depending on the venue policy.",
    },
];


const termAndConditions = [
    {
        question: "Terms & Conditions",
        answer: (<>
            <>
                <p >Please read the following terms carefully before booking your tickets:</p><br />
                <>
                    <p>Entry & Age Limit</p>
                    <ul>
                        <li>Entry is strictly for women aged 21 and above.</li>
                        <li>A valid government-issued photo ID (Aadhar card, Passport, or Driving License) must be presented at the venue.</li>
                    </ul>
                    <br />

                    <p>Booking Policy</p>
                    <ul>
                        <li>Tickets once booked are non-refundable and non-transferable.</li>
                        <li>Entry is permitted only with a valid booking confirmation (QR Code or Email Confirmation).</li>
                    </ul>
                    <br />
                    <p>Dress Code & Conduct</p>
                    <ul>
                        <li>Smart casual or party attire is recommended.</li>
                        <li>The club reserves the right to deny entry to individuals who appear to be intoxicated or are behaving inappropriately.</li>
                    </ul>
                    <br />
                    <p>Event Modifications</p>
                    <ul>
                        <li>Event schedules, artists/DJs, or venue setup may be subject to change without prior notice.</li>
                        <li>In the unlikely event of cancellation due to unforeseen circumstances, alternate arrangements will be communicated.</li>
                    </ul>

                    <br />
                    <p>Venue Rules</p>
                    <ul>
                        <li>Outside food, beverages, and illegal substances are strictly prohibited.</li>
                        <li>Smoking is permitted only in designated areas.</li>
                        <li>Management reserves the right to admission and removal from the premises if any guest violates club policies.</li>
                    </ul>

                    <br />
                    <p>Photography & Media</p>
                    <ul>
                        <li>By attending the event, guests consent to be photographed or recorded for promotional purposes.</li>
                    </ul>

                    <br />
                    <p>Health & Safety</p>
                    <ul>
                        <li>Guests are encouraged to follow basic hygiene and club safety protocols.</li>
                        <li>In case of emergency, please contact the club staff immediately.</li>
                    </ul>
                </>
            </>

        </>),
    },
]


export default function EventDetailPage() {

    const {clubdetail,  eventname } = useParams();


    const [club, city, area] = clubdetail?.split("-").map((str) => str.replace(/_/g, " "));
    const [ title] = eventname?.split("-").map((str) => str.replace(/_/g, " "));


    const [startTimeStr, setStartTimeStr] = useState("");
    const [endTimeStr, setEndTimeStr] = useState("");
    const [duration, setDuration] = useState("");
    const [eventdetails, setEventdetails] = useState([]);
    const [eventdetailsbanner, setEventdetailsbanner] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [latitude1, setLatitude1] = useState(null);
    const [longitude1, setLongitude1] = useState(null);
    const [eventId, setEventId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [recEventDetails, setRecEventDetails] = useState([]);
    const [activeVideo, setActiveVideo] = useState(null);
    const [isMuted, setIsMuted] = useState(false);
    const videoRef = useRef(null);
    var url = "https://partywitty.com/master/assets/uploads/";

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setLatitude(latitude.toString());
                    setLongitude(longitude.toString());
                    fetchEvents(latitude, longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    alert("Please enable Geo Location Service to find events details.");
                }
            );
        } else {
            console.error("Geolocation is not available in this browser.");
        }
    }, [eventname]);


    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setLatitude1(latitude.toString());
                    setLongitude1(longitude.toString());
                    fetchEvents1(latitude, longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                }
            );
        } else {
            console.error("Geolocation is not available in this browser.");
        }
    }, [eventname]);

    const fetchEvents = async (latitude, longitude) => {
        const formdata = new FormData();
        formdata.append("latitude", latitude);
        formdata.append("longitude", longitude);
        formdata.append("city", city);
        formdata.append("area", area);
        formdata.append("club", club);
        formdata.append("title", title);
        try {
            const response = await axios.post(
                "https://partywitty.com/master/APIs/Web/eventDetails",
                formdata
            )
            const eventData = response.data.data;

            setEventdetails(eventData);
            setEventdetailsbanner(response.data.data);
            setStartTimeStr(eventData.event_time);
            setEndTimeStr(eventData.event_end_time);
            setEventId(eventData.id);
            fetchEvents1(latitude, longitude, eventData.id);
        }
        catch (error) {
            console.error("Error fetching event details:", error);
        }
    };


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (startTimeStr && endTimeStr) {
            const [startHour, startMinute] = startTimeStr.split(/[:\s]/);
            const startPeriod = startTimeStr.split(' ')[1];
            const [endHour, endMinute] = endTimeStr.split(/[:\s]/);
            const endPeriod = endTimeStr.split(' ')[1];
            let start = new Date();
            let end = new Date();
            start.setHours((startPeriod === 'PM' ? 12 : 0) + (parseInt(startHour) % 12), parseInt(startMinute));
            end.setHours((endPeriod === 'PM' ? 12 : 0) + (parseInt(endHour) % 12), parseInt(endMinute));
            if (end < start) {
                end.setDate(end.getDate() + 1);
            }
            const timeDifference = end - start;
            const hours = Math.floor(timeDifference / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            setDuration(`${hours} hours ${minutes} minutes`);
        }
    }, [startTimeStr, endTimeStr]);



    const [isContentVisible, setIsContentVisible] = useState(false);

    const fetchEvents1 = async (latitude1, longitude1, eventId) => {
        const formdata = new FormData();
        formdata.append('latitude', latitude1);
        formdata.append('longitude', longitude1);
        formdata.append('event_id', eventId);

        try {
            const response = await axios.post(
                'https://partywitty.com/master/APIs/ClubEvent/recommendedEvents',
                formdata
            );
            const eventData = response.data.data;
            setRecEventDetails(eventData);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching event details:', error);
            setIsLoading(false);
        }
    };



    const [artitst, setArtitst] = useState([]);

    const fetchURL = async () => {
        try {
            const response = await axios.get(
                "https://partywitty.com/master/APIs/Artist/trendingArtist"
            );
            setArtitst(response.data.data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchURL();
    }, []);


    const [recommendedEvents, setRecommendedEvents] = useState([]);

    const today = new Date().toISOString().split('T')[0];



    const fetchUpcomingEvents = async (lat, lng, date, eventId) => {
        try {
            const formData = new FormData();
            formData.append('latitude', lat);
            formData.append('longitude', lng);
            formData.append('date', date);

            const response = await axios.post(
                'https://partywitty.com/master/APIs/ClubEvent/upcomingEvents',
                formData
            );

            if (response.data.status === true) {

                const filteredEvents = response.data.data.filter(event => event?.id !== eventId);
                setRecommendedEvents(filteredEvents);

            } else {
                console.warn('No events found:', response.data.msg);
                setRecommendedEvents([]); // Clear if no events
            }
        } catch (error) {
            console.error('Error fetching upcoming events:', error);
            setRecommendedEvents([]);
        }
    };

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const latStr = latitude.toString();
                    const lngStr = longitude.toString();

                    setLatitude(latStr);
                    setLongitude(lngStr);

                    fetchUpcomingEvents(latStr, lngStr, today, eventId);
                },
                (error) => {
                    alert('Please enable Geo Location Service to find events in your locality.');
                    console.error('Error in finding location:', error);
                }
            );
        } else {
            console.error('Geolocation is not available in this browser.');
        }
    }, [eventname, eventId]);

    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");

        return `/event/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    }



    const [menuImages, setMenuImages] = useState([]);

    const [id, setId] = useState(null);
    const clubN = club;
    const newApi = new FormData();
    newApi.append("city", city);
    newApi.append("area", area);
    newApi.append("club", clubN);

    useEffect(() => {
        axios
            .post("https://partywitty.com/master/APIs/Web/getClubDetails", newApi)
            .then((response) => {
                const id = response.data.data.id;
                setId(id);

            })
            .catch((error) => {
                console.error(error);
            });
    }, [eventname]);


    const clubid1 = new FormData();
    clubid1.append("club_id", id);

    useEffect(() => {
        if (id) {
            axios
                .post("https://partywitty.com/master/Api/getDataPost/clubMenu", clubid1)
                .then((response) => {
                    if (response.data.status) {
                        setMenuImages(response.data.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [id]);

    const generateRelatedLinks = (club, city, area) => {
        // Capitalize first letter of each word
        const format = (str) =>
            str
                .toLowerCase()
                .replace(/_/g, " ")
                .replace(/\b\w/g, (c) => c.toUpperCase());

        const formattedCity = format(city);      // Noida
        const formattedArea = format(area);      // Sector 38
        const formattedClub = format(club);  // F Bar

        return [
            {
                id: 1,
                url: `/events-test`,
                tag: `Events in ${formattedArea}`,
            },
            {
                id: 2,
                url: `/events-test`,
                tag: formattedArea,
            },
            {
                id: 3,
                url: `/events-test`,
                tag: `${formattedArea} Events`,
            },
            {
                id: 4,
                url: `/events-test`,
                tag: `${formattedArea} Events in ${formattedCity}`,
            },
            {
                id: 5,
                url: `/events-test`,
                tag: `${formattedCity} Events`,
            },
            {
                id: 6,
                tag: `${formattedCity} ${formattedArea} Events`,
            },
            {
                id: 7,
                tag: `music Dining in ${formattedArea}`,
            },
            {
                id: 8,
                tag: `events in ${formattedArea}`,
            },
            {
                id: 9,
                tag: `events in ${formattedCity}`,
            },
            {
                id: 10,
                tag: `${formattedClub} - ${formattedArea} - ${formattedCity}`,
            },
        ];
    };

    const relatedLinks = generateRelatedLinks(club, city, area);

    const [activeTab, setActiveTab] = useState(0);

    const [copySuccess, setCopySuccess] = useState(false);


    const handleShare = (platform) => {
        const currentURL = window.location.href;
        const shareText = "Check out this link: " + currentURL;

        let shareURL = "";

        switch (platform) {
            case "facebook":
                shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}&quote=${encodeURIComponent(shareText)}`;
                break;

            case "whatsapp":
                const message = `Check out this event on PartyWitty:\n${currentURL}`;
                shareURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
                break;

            case "twitter":
                shareURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentURL)}&text=${encodeURIComponent(shareText)}`;
                break;

            case "instagram":
                // Instagram does NOT support direct web sharing like others
                alert("Instagram does not support direct web sharing. Please share manually.");
                return;

            case "clipboard":
                navigator.clipboard.writeText(currentURL)
                    .then(() => {
                        setCopySuccess(true);
                        setTimeout(() => setCopySuccess(false), 2000);
                    })
                    .catch(() => {
                        setCopySuccess(false);
                    });
                return;

            default:
                return;
        }

        // Open the share URL in a new tab
        window.open(shareURL, "_blank");
    };



    if (!eventdetails) {
        return <div>Loading...</div>;
    }




    return (
        <>
            <div className='event-detail-page'>
                <div className='event-detail-page-design-container'>
                    <div className='event-detail-page-design-wrapper'>

                        {/* main section */}
                        <div className='event-detail-page-design-content'>

                            <div className='event-detail-page-design-content1'>

                                {eventdetailsbanner?.image ? (<div className='event-detail-page-design-content1-img' style={{ backgroundImage: `url(${url + eventdetailsbanner?.image})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                                    <div className="event-detail-page-design-content1-img-blur-overlay">
                                        <img src={url + eventdetailsbanner?.image} alt='img' />
                                    </div>
                                </div>) : (
                                    <>
                                        <div className='event-detail-page-design-content1-img'>
                                            <div className="event-detail-page-design-content1-img-blur-overlay about-event-shimmer"> </div>
                                        </div>
                                    </>
                                )}



                                {/* only mobile view */}
                                <div className='event-detail-page-design-content-sidebar-mobile-view'>
                                    <div className='event-detail-page-design-content-sidebar-offer'>
                                        <div className='event-detail-page-design-content-sidebar-offer-heading'>
                                            <h1>Get Rs. 200 Off* on your First Table Booking </h1>
                                            <p>Book Through pertywitty.com </p>
                                        </div>
                                        <div className='event-detail-page-design-content-sidebar-offer-button'>
                                            <button>Reserve Now</button>
                                        </div>
                                    </div>
                                </div>

                                <div className='event-detail-page-design-content-sidebar-mobile-view'>
                                    <div className=''>
                                        <h1>{eventdetails?.name}</h1>
                                        <p>{eventdetails?.clubName}</p>

                                        <div className='event-detail-page-design-content-sidebar-data-time'>
                                            <div className='edpdcsdt-data'><SlCalender size={20} color='#787579' /> {eventdetails?.event_date}</div>
                                            <div className='edpdcsdt-data'><IoTimeOutline size={20} color='#787579' /> {startTimeStr} - {endTimeStr}</div>
                                            {eventdetails?.clubAddress && <div className='edpdcsdt-data'><FaLocationDot size={20} color='#787579' /> {eventdetails?.clubAddress}</div>}
                                        </div>
                                    </div>
                                </div>


                                <div className='event-detail-page-design-content-section'>
                                    <div className="event-detail-page-design-content1-about">
                                        <h2>About the Event</h2>
                                        <p dangerouslySetInnerHTML={{ __html: eventdetails?.event_des }}></p>
                                        <p >Get ready to experience the most talked-about <span className="event-detail-page-design-content1-about-span-bold">
                                            {eventdetails?.name?.includes("@") ? eventdetails.name.split("@")[0] : ""}
                                        </span> at the iconic {eventdetails?.clubName}, located in <span className="event-detail-page-design-content1-about-span-bold">{eventdetails?.clubAddress || "Sector 38, Noida"}</span>, . On <span className="event-detail-page-design-content1-about-span-bold">{eventdetails?.event_date}</span>, the dance floor comes alive with an electrifying DJ party in Noida, curated exclusively for the ladies who love to party in style.<br />
                                            <br />This exciting <span className="event-detail-page-design-content1-about-span-bold">
                                                {eventdetails?.name?.includes("@") ? eventdetails.name.split("@")[0] : "" + eventdetails?.clubName}
                                            </span> promises a blend of glamour, music, and fun. From the moment you walk in, you’ll be greeted with a complimentary welcome drink, vibrant lighting, and a lineup of popular DJs spinning the hottest Bollywood, EDM, and Commercial hits all night long.
                                            <br />
                                            <br />
                                            Whether you're looking for the perfect midweek break or planning a celebration with your girl gang, this event is part of the top weekend-style parties in Noida — but happening on a weekday!
                                            So put on those heels, bring your vibe, and let the bass drop at the most happening <span className="event-detail-page-design-content1-about-span-bold">
                                                {eventdetails?.name?.includes("@") ? eventdetails.name.split("@")[0] : ""}
                                            </span>. Live it up now!
                                        </p>
                                    </div>
                                </div>

                                <div className='event-detail-page-design-content-section-faq'>
                                    <Accordion faqs={faqs} />
                                </div>
                                <div className='event-detail-page-design-content-section-terms-and-conditions'>
                                    <h2>Terms & Conditions</h2>
                                    <Accordion faqs={termAndConditions} />
                                </div>

                                <div className='event-detail-page-design-content-sidebar-menu'>
                                    {menuImages.length === 0 ? (
                                        <div className='event-detail-page-design-content-sidebar event-detail-card-info'>
                                            <div className='about-event-skeleton'>
                                                <div className='about-event-skeleton-title about-event-shimmer'></div>
                                                <div className='about-event-skeleton-subtitle about-event-shimmer'></div>
                                            </div>
                                            <div className="edpdcs-tab-content">
                                                <div className='image-menu-card-skeleton about-event-shimmer'></div>
                                            </div>
                                        </div>

                                    ) : (<div className="ed-menu-card-section">
                                        <h1>Menu</h1>
                                        <div className="edpdcs-tab-headers">
                                            {menuImages.map((data, index) => (
                                                <button
                                                    key={index}
                                                    className={`edpdcs-tab-button ${activeTab === index ? 'edpdcs-active' : ''}`}
                                                    onClick={() => setActiveTab(index)}
                                                >
                                                    {data?.title_name}
                                                </button>
                                            ))}
                                        </div>

                                        <div className="edpdcs-tab-content">
                                            <EventDetailmenuImageSlider images={menuImages[activeTab]?.images} />
                                        </div>
                                    </div>)}
                                </div>


                            </div>


                            <div className='event-detail-page-design-content-sidebar-section'>

                                {eventdetails.length === 0 ? (
                                    <div className='event-detail-page-design-content-sidebar event-detail-card-info'>
                                        <div className='about-event-skeleton'>
                                            <div className='about-event-skeleton-title about-event-shimmer'></div>
                                            <div className='about-event-skeleton-subtitle about-event-shimmer'></div>

                                            <div className='event-detail-page-design-content-sidebar-data-time'>
                                                <div className='about-event-skeleton-icon-text about-event-shimmer'></div>
                                                <div className='about-event-skeleton-icon-text about-event-shimmer'></div>
                                                <div className='about-event-skeleton-icon-text about-event-shimmer'></div>
                                            </div>
                                            <div className='event-detail-page-design-content-sidebar-data-footer'>
                                                <div className='about-event-skeleton-icon-text about-event-shimmer'>

                                                </div>
                                                <div className='about-event-skeleton-icon-text about-event-shimmer'>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='event-detail-page-design-content-sidebar event-detail-card-info'>
                                        <h1>{eventdetails?.name}</h1>
                                        <p>{eventdetails?.clubName}</p>

                                        <div className='event-detail-page-design-content-sidebar-data-time'>
                                            <div className='edpdcsdt-data'><SlCalender size={20} color='#787579' /> {eventdetails?.event_date}</div>
                                            <div className='edpdcsdt-data'><IoTimeOutline size={20} color='#787579' /> {startTimeStr} - {endTimeStr}</div>
                                            {eventdetails?.clubAddress && <div className='edpdcsdt-data'><FaLocationDot size={20} color='#787579' /> {eventdetails?.clubAddress}</div>}
                                        </div>

                                        <div className='event-detail-page-design-content-sidebar-data-footer'>
                                            <div className='edpdcsdf-data-heading'>
                                                <h1>₹100/person</h1>
                                                <p>20% off on Booking</p>
                                            </div>
                                            <Link to={`/event-book/${eventdetails.club_id}/${eventdetails.id}`} style={{ textDecoration: "none" }}>
                                            <div className='edpdcsdf-data-button'>
                                                <button>Book Now</button>
                                            </div>
                                            </Link>

                                        </div>
                                    </div>
                                )}





                                <div className='event-detail-page-design-content-sidebar-offer'>
                                    <div className='event-detail-page-design-content-sidebar-offer-heading'>
                                        <h1>Get Rs. 200 Off* on your First Table Booking </h1>
                                        <p>Book Through pertywitty.com </p>
                                    </div>
                                    <div className='event-detail-page-design-content-sidebar-offer-button'>
                                        <button>Reserve Now</button>
                                    </div>
                                </div>

                                <div className='event-detail-page-design-content-sidebar'>
                                    <div className="edpdcs-heading-sidebar-menu-section">Share the Event</div>
                                    <div className='event-detail-page-design-content-sidebar-share'>
                                        {/* <div className='event-detail-page-design-content-sidebar-share-icon' onClick={() => handleShare("instagram")}>
                                            <FaInstagram size={30} />
                                        </div> */}
                                        <div className='event-detail-page-design-content-sidebar-share-icon'>
                                            <FaXTwitter color='black' size={30} onClick={() => handleShare("twitter")} />
                                        </div>
                                        <div className='event-detail-page-design-content-sidebar-share-icon'>
                                            <FaFacebookSquare color='blue' size={30} onClick={() => handleShare("facebook")} />
                                        </div>
                                        <div className='event-detail-page-design-content-sidebar-share-icon'>
                                            <FaWhatsapp color='green' size={30} onClick={() => handleShare("whatsapp")} />
                                        </div>
                                        <div className='event-detail-page-design-content-sidebar-share-icon'>
                                            <MdContentCopy size={30} onClick={() => handleShare("clipboard")} />
                                        </div>
                                    </div>
                                    {copySuccess && (
                                        <div className="copy-success-text">Link copied to clipboard!</div>
                                    )}
                                </div>

                            </div>

                        </div>

                        {/* bottom  section */}
                        <div className='event-detail-page-design-bottom'>

                            <div className='event-detail-page-design-content-section-artists'>
                                <h2>Artists</h2>
                                <div className='event-detail-page-design-content-section-artists-cards-container'>
                                    {artitst.map((artist, index) => (
                                        <ArtistsCardEventDetail artist={artist} key={index} />
                                    ))}
                                </div>
                            </div>


                            <div className='event-detail-page-design-bottom-other-events-recommended'>
                                <div className='edpsboe-heading'>
                                    <h1>Recommended Events</h1>
                                    <span>
                                        <Link to='/events'>
                                            View all
                                        </Link>
                                    </span>
                                </div>
                                <div className='event-detail-page-design-bottom-other-events-recommended-cards-container'>
                                    {recommendedEvents.slice(0, 3).map((event, index) => (
                                        <Link to={generateClubUrl(event.clubName, event.cityName, event.areaName, event.name)} key={index}>
                                            <EventsListingCard title={event.name} date={event.event_date} time={event.event_time} rating={event.rating} location={event.cityName} distance={event.distance} type={event.categoryName} price={event.min_price} image={url + event.image} offer={event.offer} />
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            <div className='event-detail-page-design-bottom-promotional-banner'>
                                <div className='event-detail-page-design-bottom-promotional-banner-content'>
                                    <div className='event-detail-page-design-bottom-promotional-banner-content-heading'>
                                        <h1>Stay updated, book exclusive offers & events instantly with PartyWitty App.</h1>
                                    </div>
                                    <div className='event-detail-page-design-bottom-promotional-banner-content-images'>
                                        <a href="https://apps.apple.com/in/app/partywitty/id6478442502">
                                            <img src={footer1} alt="" />
                                        </a>
                                        <a href="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                                            <img src={footer2} alt="" />
                                        </a>
                                    </div>
                                </div>
                                <div className='event-detail-page-design-bottom-promotional-banner-image'>
                                    <img src={promotion} alt="" />
                                </div>
                            </div>


                            <div className='event-detail-page-design-bottom-footer-tags-section'>
                                {/* <h1>You May Also Like This</h1> */}
                                <div className='event-detail-page-design-bottom-footer-tags'>
                                    <div className='event-detail-page-design-bottom-footer-tags-text'>
                                        <h1> Discover the Best Live Music Events Near You</h1>
                                        <p>Searching for top live music events happening around you? Partywitty is your go-to platform for discovering high-energy DJ nights, live band performances, acoustic sets, and underground music gigs across Delhi, Noida, Gurugram, and nearby cities. From weekend live music shows to mid-week performances, explore a curated list of trending events with real-time booking options. Whether you enjoy EDM, rock, jazz, or indie vibes — experience the rhythm of nightlife like never before with Partywitty. </p>
                                    </div>
                                    <div className='event-detail-page-design-bottom-footer-tags-text'>
                                        <h1>Exclusive Table & Group Booking Deals via App</h1>
                                        <p>Looking to reserve a VIP table or plan a group night out? With the Partywitty app, you’ll unlock exclusive access to the best deals on table bookings and group party packages across the hottest clubs and lounges in Delhi NCR, Noida, Gurugram, and more. Whether you're celebrating a special occasion or just want hassle-free entry with your friends, our app helps you secure premium spots in advance. Download now to find the deal that fits your vibe — directly through the Partywitty application!</p>
                                    </div>
                                    <div className='event-detail-page-design-bottom-footer-tags-text'>
                                        <h1>Find Top Weekend Parties & Clubbing Events</h1>
                                        <p>Never miss out on the most happening weekend parties and electrifying clubbing events in Noida, Delhi NCR, Gurugram, and other metro cities. Partywitty helps you explore top-rated nightlife experiences — from Bollywood dance nights and EDM shows to house music takeovers and rooftop parties. Discover trending events, verified artist lineups, and premium venues all in one place. Whether you're planning a fun night out with friends or looking to explore the city's party scene, Partywitty makes your party booking effortless and exciting.</p>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <FooterTagSection relatedLinks={relatedLinks} clubInfo={eventname} />
                            </div>
                        </div>


                        {/* for mobile view only */}
                        <div className='event-detail-page-design-content-sidebar-data-footer-mobile'>
                            <div className='edpdcsdf-data-heading'>
                                <h1>₹100/person</h1>
                                <p>20% off on Booking</p>
                            </div>
                            <div className='edpdcsdf-data-button'>
                                <button>Book Now</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
